import { transparentize } from 'polished';
import { gray4, slate3 } from './base';

export const divider1 = transparentize(0.75, gray4);
export const divider2 = transparentize(0.6, gray4);
export const divider3 = slate3;
